var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProdutorRural(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22L42 23.8C43.2 23.8 43.8 24.8 43.6 26L42 36H40M40 36C40 38.2091 38.2091 40 36 40C33.7909 40 32 38.2091 32 36M40 36C40 33.7909 38.2091 32 36 32C33.7909 32 32 33.7909 32 36M32 36H22M36 10C35.4696 10 34.9609 10.2107 34.5858 10.5858C34.2107 10.9609 34 11.4696 34 12V23.146M6 8H24L26 22.492M8 22V8M14 30H14.02M16 20.2V8M24 30C24 35.5228 19.5228 40 14 40C8.47715 40 4 35.5228 4 30C4 24.4772 8.47715 20 14 20C19.5228 20 24 24.4772 24 30Z",
    stroke: "#022A59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProdutorRural);
export default __webpack_public_path__ + "static/media/icon-produtor-rural.2dd1cfe6.svg";
export { ForwardRef as ReactComponent };